import { render, staticRenderFns } from "./vir.vue?vue&type=template&id=047782ea&"
import script from "./vir.vue?vue&type=script&lang=js&"
export * from "./vir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports